import { render, staticRenderFns } from "./ModalDeleteRole.vue?vue&type=template&id=aa4dc3b8&"
import script from "./ModalDeleteRole.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports